import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  params: { lang: 'en' }, // Default language
});

export const fetchNews = async ({ category, dateRange, page, lang, mediaType, search, limit }) => {
  try {
    const response = await apiClient.get(endpoints.news.list, {
      params: {
        category,
        created_after: dateRange?.start,
        created_before: dateRange?.end,
        page: page || 1,
        lang,
        media_type: mediaType,
        search,
        limit,
        ordering: '-created_at',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch news');
  }
};

export const fetchNewsDetails = async (slug, lang) => {
  try {
    const response = await apiClient.get(endpoints.news.detail(slug), {
      params: { lang },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching news details:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch news details');
  }
};

export const fetchNewsCategories = async (lang) => {
  try {
    const response = await apiClient.get(endpoints.news.categories, {
      params: { lang },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching news categories:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch news categories');
  }
};

export const fetchResources = async (lang) => {
  try {
    const response = await apiClient.get(endpoints.resources.list, {
      params: { lang },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching resources:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch resources');
  }
};

/**
 * Increment view count for a news article
 * Uses rate limiting on the backend to prevent spam
 * @param {string} slug - The news article slug
 * @returns {Promise<{views: number, rate_limited: boolean}>}
 */
export const incrementNewsView = async (slug) => {
  try {
    const response = await apiClient.post(endpoints.news.incrementView(slug));
    return response.data;
  } catch (error) {
    // Silently fail - view counting is not critical
    console.warn('Error incrementing view count:', error);
    return null;
  }
};